export const getQueryParam = name => {
  return new URLSearchParams(window.location.search).get(name);
};

export const updatePlaygroundUrl = ({ demo, platform }) => {
  const url = new URL(window.location.href);

  if (platform) {
    url.searchParams.set("mode", platform);
  }

  if (demo) {
    url.searchParams.set("demo", demo);
  }

  window.history.pushState({}, "", `${url.pathname}${url.search}${url.hash}`);
};
